const React = require('react');
const { wrapFunctionalComponent } = require('utils/framework').default;
const { space, site } = require('style/config');
const getBaseComponent = require('utils/framework/getBaseComponent').default;
const getStyledComponent = require('utils/framework/getStyledComponent').default;
const styledSpace = require('styled-system').space;
const theme = require('style/theme');

const StyledComponent = getStyledComponent({
    InnerComp: getBaseComponent({
        elementType: 'div',
        isBasicElement: false,
        useRef: true
    }),
    styledProps: [
        props => [
            {
                width: '100%',
                maxWidth: props.hasLegacyWidth ? site.legacyWidth + space.container * 2 : site.containerMax + space.container * 2
            },
            styledSpace,
            props.css
        ]
    ]
});

const Container = React.forwardRef((props, ref) => {
    return (
        <StyledComponent
            __ref={ref}
            {...props}
        />
    );
});

Container.defaultProps = {
    theme,
    paddingX: 'container',
    marginX: 'auto'
};

module.exports = wrapFunctionalComponent(Container, 'Container');
